module.exports = __webpack_public_path__ + "img/wijwetendingen_logo_white.73ce6dce.png";